<template>
  <div class="galleryvr Page">
    <div class="Page-Content Page-Content1">
      <div class="gallery-group">
        <div class="gallery-item growFromScaleAnimation" @click="showVr({type:'vr',media:'https://arinaeastresidences.com.sg/VR/A1/'})">
          <div class="item-img col">
            <img class="" src="@/assets/gallery/typeA.png" alt="" />
            <h2>Type A</h2>
          </div>
        </div>
        <div class="gallery-item growFromScaleAnimation" @click="showVr({type:'vr',media:'https://arinaeastresidences.com.sg/VR/B2/'})">
          <div class="item-img col">
            <img class="" src="@/assets/gallery/typeB2.png" alt="" />
            <h2>Type B2</h2>
          </div>
        </div>
        <div class="gallery-item growFromScaleAnimation" @click="showVr({type:'vr',media:'https://arinaeastresidences.com.sg/VR/D2b/'})">
          <div class="item-img col">
            <img class="" src="@/assets/gallery/typeD2a.png" alt="" />
            <h2>Type D2a</h2>
          </div>
        </div>
      </div>
    </div>

    <!-- 其他媒体 -->
    <div v-if="showMedia" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-color: black;z-index: 2000;">
      <iframe style="width: 100%;height: 100%;" :src="showMediaData.media" frameborder="0"></iframe>
      <div @click="showMedia=false" style="position: absolute;top: 49%;right: 20px;color: black;background-color: white;padding: 5px;cursor: pointer;border-radius: 5px;z-index: 999;">Close</div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      showMedia:false,
      showMediaData:{},
    };
  },
  methods: {
    showVr(item){
      this.showMedia = true;
      this.showMediaData = item
    },

  },
  mounted() {

  },
};
</script>

<style lang="less">

.galleryvr {
  .Page-Content1{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .gallery-group{
    width: 80%;
    margin: auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    .gallery-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      // width: 320px;
      height: 35vh;
      margin: 20px;
      .item-img{
        position: relative;
        width: 100%;
        height: 90%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5px;
        filter: brightness(0.7);
        // filter: brightness(50%);
      }
      h2{
        position: absolute;
        color: #e59c4d;
        text-shadow: 2px 2px 4px #000;
      }
      }

    }
  }

}


@media screen and (max-width:800px) {
  .gallery-group {
    grid-template-columns: repeat(1, 1fr) !important;
  }
  .Page-Content1{
    width: 100%;
    height: auto;
    overflow: hidden;
  }
  .close-btn {
    top: 10px;
    right: 10px;
  }
}
</style>

